<h3>{{'myUsers.selectFields' | translate}}</h3>

<div class="field-container">
  <div *ngFor="let field of fields" class="field">
    <mat-checkbox [(ngModel)]="field.selected">{{field.title || field.translation | translate}}</mat-checkbox>
  </div>
</div>

<div class="button-container">
  <button (click)="abort()" class="ibexfusion-raised-button" mat-button>{{'general.cancel' | translate}}</button>
  <button (click)="finish()" class="ibexfusion-raised-button" mat-button>{{'myUsers.export' | translate}}</button>
</div>
